import React from 'react';

import './ExportDisclaimer.scss';

function ExportDisclaimer() {
  const EXPORT_DISCLAIMER_LINK = 'https://www.elsevier.com/legal/elsevier-website-terms-and-conditions?dgcid=RN_AGCM_Sourced_300005028';
  return (
    <div className="export-disclaimer">
      <div className="export-disclaimer__icon">i</div>
      <div className="export-disclaimer__content">
        <span>
          <b>Disclaimer:</b> please refer to our{' '}
          <a
            data-e2e="export-terms-and-conditions"
            href={EXPORT_DISCLAIMER_LINK}
            target="_blank"
            className="els-btn els-btn-link els-btn-sm"
            rel="noreferrer">
            <span>Terms and Conditions</span>
          </a>{' '}
          before downloading data.
        </span>
      </div>
    </div>
  );
}

export default ExportDisclaimer;
